exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-tabs > li {\n  cursor: pointer;\n  padding:10px;\n}\n\n.nav-tabs>li.active {\n  border-top: 0 !important;\n  border-bottom: 3px solid #04aeff;\n  font-weight:bold;\n}\n.disabled {\n  pointer-events: none;\n  cursor: crosshair;\n  opacity: 0.5;\n}\n\n.list-group-item {\n  border-bottom: none;\n}\n\n.list-group-item > .form-group {\n  margin-bottom: 0;\n}\n\nli:active, a:active, .active:active, li:focus, a:focus, .active:focus {\n  outline: none;\n}\n.segment{\n  margin-top: 31px !important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/bizisystem-frontend/src/src/app/main/pages/organization-detail/organization-detail.component.css
// module id = ../../../../../src/app/main/pages/organization-detail/organization-detail.component.css
// module chunks = main